import { MouseEventHandler } from 'react';

import { Text as LegacyText } from '@chakra-ui/react';
import { Box, Flex, keyframes } from '@joinrepublic/dls-ui-kit';

import { IFounderSpotlight } from '../founder-spotlight/types';

type ICarouselControl = Pick<IFounderSpotlight, 'company'> & {
  isActive: boolean;
  delay: number;
  onClick?: MouseEventHandler<HTMLHeadingElement>;
};

const growAnimation = keyframes`
  from { width: 2%; }
  to { width: 100%; }
`;

export const CarouselControl = ({
  company,
  isActive,
  delay,
  onClick,
}: ICarouselControl) => {
  return (
    <Flex
      onClick={onClick}
      gap="0.5"
      flexDirection="column"
      cursor="pointer"
      flex="1"
    >
      <LegacyText
        display={{ base: 'none', sm: 'block' }}
        fontSize="14px"
        color="white"
      >
        {company}
      </LegacyText>
      <Box
        height={{ base: '2px', sm: '4px' }}
        background="whiteAlpha.500"
        position="relative"
      >
        {isActive ? (
          <Box
            height="100%"
            width="0%"
            background="white"
            position="absolute"
            opacity="0.95"
            animation={`${growAnimation} ${delay}ms linear forwards`}
          ></Box>
        ) : null}
      </Box>
    </Flex>
  );
};
